import { useCallback, useState } from "react";
/**
 * @param {boolean} [initialValue=false]
 */
export var use2State = function (initialValue) {
    if (initialValue === void 0) { initialValue = false; }
    var _a = useState(initialValue), state = _a[0], setState = _a[1];
    var positive = useCallback(function () {
        setState(true);
    }, [setState]);
    var negative = useCallback(function () {
        setState(false);
    }, [setState]);
    var toggle = useCallback(function () {
        setState(function (prev) { return !prev; });
    }, [setState]);
    var reset = useCallback(function () {
        setState(initialValue);
    }, [setState, initialValue]);
    return {
        state: state,
        positive: positive,
        negative: negative,
        toggle: toggle,
        reset: reset,
    };
};
//# sourceMappingURL=use2State.js.map